module.exports = __webpack_public_path__ + "img/us-flag.0bb21e7b.png";